import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ReportEditor from './ReportEditor';

import logger from 'utils/logger';
import ReportPreview from './ReportPreview';
import { zIndexValues } from 'utils/styles';

const propTypes = {
  reportContent: PropTypes.object,
  setReportContent: PropTypes.func,
  modalClose: PropTypes.func,
  openViewer: PropTypes.func,
  shouldAllowOpenViewer: PropTypes.bool,
  saveReportContent: PropTypes.func,
  keyImages: PropTypes.array,
  setKeyImages: PropTypes.func,
  isPreview: PropTypes.bool,
};

const log = logger.createLogger('ReportEditor');

// If the file data is sent then open the preview
const ReportModal = ({
  reportContent,
  setReportContent,
  modalClose,
  openViewer,
  shouldAllowOpenViewer,
  saveReportContent,
  keyImages,
  setKeyImages,
  isPreview = false,
}) => {
  const [shouldShowPreview, setShouldShowPreview] = useState(true);
  const [shouldShowEditor] = useState(!isPreview);
  const [isPreviewLoading, setIsPreviewLoading] = useState(true);

  //[KEEP] For debugging purposes
  const [debugBox, setDebugBox] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const [reRender, setReRender] = useState(0);

  const togglePreview = () => {
    setShouldShowPreview(!shouldShowPreview);
  };

  const handlePreviewLoadingStateChange = (isLoading) => {
    setIsPreviewLoading(isLoading);
  };

  return (
    <Fragment>
      <div
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: '100%',
        }}>
        <Grid container>
          <Grid size={12} sx={{ background: '#525659' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton onClick={modalClose}>
                <CloseIcon sx={{ color: '#fff' }} />
              </IconButton>
            </div>
          </Grid>

          {shouldShowEditor && (
            <Grid
              size={shouldShowPreview ? 6 : 12}
              sx={{ height: '80vh', overflow: 'hidden', position: 'relative' }}>
              <div style={{ height: '100%', overflow: 'auto' }}>
                {isPreviewLoading && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      zIndex: zIndexValues.modal,
                      pointerEvents: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                    <CircularProgress />
                  </Box>
                )}
                <ReportEditor
                  reportContent={reportContent}
                  togglePreview={togglePreview}
                  debugBox={debugBox}
                  setDebugBox={setDebugBox}
                  setReRender={setReRender}
                  setReportContent={setReportContent}
                  openViewer={openViewer}
                  shouldAllowOpenViewer={shouldAllowOpenViewer}
                  saveReportContent={saveReportContent}
                  keyImagesFromViewer={keyImages}
                  setKeyImagesFromViewer={setKeyImages}
                />
              </div>
            </Grid>
          )}
          {shouldShowPreview && (
            <Grid size={shouldShowEditor ? 6 : 12} sx={{ height: '80vh' }}>
              <ReportPreview
                reportContent={reportContent}
                debugBox={debugBox}
                reRender={reRender}
                onLoadingStateChange={handlePreviewLoadingStateChange}
              />
            </Grid>
          )}
        </Grid>
      </div>
    </Fragment>
  );
};

ReportModal.propTypes = propTypes;

export default ReportModal;
